export default "__VITE_ASSET__CZZHLE1N__"